var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3426_548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2695 68.2747C83.8883 52.6559 83.8883 27.3329 68.2695 11.7141C52.6508 -3.90466 27.3278 -3.90466 11.709 11.7141C-3.90978 27.3329 -3.90978 52.6559 11.709 68.2747C27.3278 83.8934 52.6508 83.8934 68.2695 68.2747Z",
    fill: "url(#paint0_linear_3426_548)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.062 13.5347C50.831 13.5347 59.1956 22.6669 59.1956 33.2327C59.1956 43.7985 40.7393 66.4654 40.062 66.4654C39.3847 66.4654 20.8042 43.7985 20.8042 33.2327C20.8042 22.6669 29.293 13.5347 40.062 13.5347Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2767 44.2952C46.4175 44.2952 51.3956 39.3171 51.3956 33.1763C51.3956 27.0354 46.4175 22.0573 40.2767 22.0573C34.1358 22.0573 29.1577 27.0354 29.1577 33.1763C29.1577 39.3171 34.1358 44.2952 40.2767 44.2952Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 22.93
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3426_548",
    x1: 11.709,
    y1: 11.7141,
    x2: 68.2695,
    y2: 68.2747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D008B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3426_548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.81303b0c4305ab9f8dcfbbf112c01651.svg";
export { ForwardRef as ReactComponent };